import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { check } from '@/config/colors';
import { localTime } from '../../Common/timeUtils';
import { TLStops , Delivery } from '@/config/types/Routes';

interface TooltipProps {
  stop: TLStops;
  delivery: Delivery;
}
const useStyles = makeStyles(theme => ({
  addressDetails: {
    paddingTop: theme.spacing(2),
    color: 'white',
  },
  textstyle: {
    textTransform: 'capitalize'
  }
}));

export default function tooltipContent({ stop, delivery }: TooltipProps) {
  if (!stop) {
    return (
      <div className="tooltip">
        <Typography style={{ color: check }}>
          BREAK
        </Typography>
      </div>
    );
  }
  const { location } = stop;
  const classes = useStyles();
  return (
    <div className="tooltip">
      <Typography color={'white'}>
        {`ETA: ${localTime(new Date(stop?.arrival_time))}`}
      </Typography>
      <div className={classes.addressDetails}>
        <Typography className={classes.textstyle}>
          {location?.address?.contactfirstname ? location?.address?.contactfirstname : ' '} {location?.address?.contactlastname ? location?.address?.contactlastname : ' '}
        </Typography>
        <Typography  className={classes.textstyle}>
          {location?.address?.street ? location?.address?.street : ''} {location?.address?.house_number ? location?.address?.house_number : ''}
        </Typography>
        <Typography  className={classes.textstyle}>
          {location?.address?.postal_code ? `${location?.address?.postal_code} ` : ''} {location?.address?.city ? location?.address?.city : ''}
        </Typography>
      </div>
    </div>
  );
}

tooltipContent.propTypes = {
  delivery: PropTypes.object.isRequired,
  multi_contains_pickup_id: PropTypes.bool,
  multi_contains_pickup_ref_id: PropTypes.bool
};
